import React from 'react';
import styles from './DownloadPendingPopup.module.scss';
import {commonImages} from '../../assets/images';
import strings from '../../globalization';

const DownloadPendingPopup = ({message, onClose, onViewReports}) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrap}>
        <img src={commonImages.infoIcon} alt="" className={styles.icon} />
      </div>
      <h3 className={styles.title}>Report Generation Started</h3>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primaryBtn}
          onClick={onViewReports}>
          View Generated Reports
        </button>
        <button type="button" className={styles.secondaryBtn} onClick={onClose}>
          {strings.okayPopup}
        </button>
      </div>
    </div>
  );
};

export default DownloadPendingPopup;
